import React, { Component } from "react";
import MemberNavigationTabs from "../../../components/NavigationTabs/MemberNavigationTabs";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import MemberInfo from "./Pages/MemberInfo";
import connect from "react-redux/es/connect/connect";
import ls from 'localstorage-slim';
import MemberCards from "./Pages/MemberCards";
import MemberTickets from "./Pages/MemberTickets";
import queryString from "query-string";
import Page404 from "../../../components/Page404/Page404";

class MemberPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            token: '',
            isMemberFound: true,
        }
    }

    handleLang = (lang) => {
        const acceptedLangs = ['en', 'rs'];
        if (!lang || !acceptedLangs.some((key) => key == lang)) {
            ls.set('targetLang', 'rs')
            return;
        }

        ls.set('targetLang', lang)
    };

    handleChangeMemberFound = (result) => {
      if (result) {
        ls.set('isRefreshed', false);
      }
      this.setState({ isMemberFound: result });
    }

    componentDidMount() {
        const { params } = this.props.match;

        this.setState({ token: params.accessToken });
        var oldToken = ls.get('member-access-token', '');
        ls.set('member-access-token', params.accessToken);

        if (oldToken != params.accessToken) {
            window.location.reload(); 
        }

        this.handleLang(queryString.parse(window.location.search).lang);
    }

    render() {
        const { isMemberFound } = this.state;

        if (!isMemberFound) {
            var isRefreshed = ls.get('isRefreshed');
            console.log(isRefreshed);
            if (!isRefreshed) {
                const { params } = this.props.match;

                this.setState({ token: params.accessToken });
                ls.set('member-access-token', params.accessToken);
                ls.set('isRefreshed', true);
                window.location.reload(); 
            }
          return <Page404 isBackBtn={false} isRefreshAvailable={true} />;
        }

        return <>
            <section style={{ paddingTop: '80px' }}>
                <div className='new-event__nav'>
                    <MemberNavigationTabs />
                </div>

                <Switch>
                    <Redirect
                        from={ROUTES.MEMBER_NEW}
                        to={ROUTES.MEMBER_NEW_INFO}
                        exact
                    />

                    <Route
                      path={ROUTES.MEMBER_NEW_INFO}
                      exact
                      render={(props) => <MemberInfo {...props} handleChangeMemberFound={this.handleChangeMemberFound} />}
                    />
                    <Route path={ROUTES.MEMBER_NEW_CARDS} exact component={MemberCards} />
                    <Route path={ROUTES.MEMBER_NEW_EVENTS} exact component={MemberTickets} />

                </Switch>

            </section>
        </>
    }
}

const mapStateToProps = ({
    auth: { user },
    events: { currentEvent, loading, error, currentTicket },
}) => ({ user, currentEvent, loading, error, currentTicket });

const mapDispatchToProps = (dispatch) => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(MemberPage));